import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest} from '@angular/common/http';
import {catchError, switchMap} from 'rxjs/operators';
import {Observable, of, throwError} from 'rxjs';
import {AuthenticationService} from './authentication.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {CustomHttpUrlEncodingCodec} from '../../generated/encoder';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

  constructor(
    public authenticationService: AuthenticationService,
    public utilsService: UtilsService,
  ) {
  }

  inflightAuthRequest$ = null;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('login_check')
      || req.url.includes('refresh_token')
      || req.url.includes('/token/refresh')
      || req.url.includes('/reset-password-confirmation')
      || req.url.includes('/check-token-validity')
      || req.url.includes('/confirm-email-change')
      || req.url.includes('/request-reset-password')
    ) {
      return next.handle(req);
    }
    if (!this.inflightAuthRequest$) {
      this.inflightAuthRequest$ = this.authenticationService.getLocalValidTokenOrGetANewOneFromWs$();
    }
    return this.inflightAuthRequest$.pipe(
      switchMap((token) => {
        if (!token) {
          return of(null);
        }
        this.inflightAuthRequest$ = null;
        const cloneOptions: any = {
          headers: req.headers.set('Authorization', token ? 'Bearer ' + token : '')
        };
        if (this.authenticationService.userImpersonatedId) {
          cloneOptions.params = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()})
            .append('x-switch-user', this.authenticationService.userImpersonatedId);
        }
        const authReq = req.clone(cloneOptions);
        return next.handle(authReq);
      }),
      catchError((error: any) => {
        if (error.status === 401 && error.error['message'] === 'Invalid JWT Token') {
          this.utilsService.unlockUi();
          this.inflightAuthRequest$ = null;
          return of(null);
        } else {
          this.utilsService.unlockUi();
          this.inflightAuthRequest$ = null;
          return throwError(error);
        }
      })
    );
  }
}
